export default __webpack_public_path__ + "static/media/favicon.c8b5bcaa.ico";